import React, { useState, useContext } from "react";
import moment from "moment";
import TextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Checkbox from "@material-ui/core/Checkbox";
import Fab from "@material-ui/core/Fab";
import SearchOutlinedIcon from "@material-ui/icons/SearchOutlined";
import CircleUnchecked from "@material-ui/icons/RadioButtonUnchecked";
import RadioButtonCheckedOutlinedIcon from "@material-ui/icons/RadioButtonCheckedOutlined";
import FilterListOutlinedIcon from "@material-ui/icons/FilterListOutlined";
import ArrowForwardIosOutlinedIcon from "@material-ui/icons/ArrowForwardIosOutlined";
import { ReactComponent as ArrowDown } from "../../assets/icon/keyboard_arrow_down-24px.svg";
import DoneIcon from "@material-ui/icons/Done";
import Chip from "@material-ui/core/Chip";

import useMediaQuery from "../../hooks/useMediaQuery";
import TableContext from "../../context/table/tableContext";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  margin: {
    margin: theme.spacing(1),
  },
  withoutLabel: {
    marginTop: theme.spacing(3),
  },
  textField: {
    width: "25ch",
  },
  dataViewFilterContainer: {
    marginTop: "30px",
  },
  dataViewFilterLabel: {
    fontSize: "14px",
    color: "#414141",
    font: "Bold 14px/16px Roboto;",
    letterSpacing: "0px",
    opacity: 1,
    fontWeight: "bold",
  },
  containerCheckbox: {
    display: "flex",
    marginTop: "15px",
  },
  labelCheckbox: {
    fontSize: "14px",
    marginTop: "2px",
  },
}));

const FiltersTransactions = (props) => {
  const tableContext = useContext(TableContext);
  const { setFilter, filters } = tableContext;
  const { terminals } = props;

  const classes = useStyles();
  const [forDay, setForDay] = useState(true);
  const [forTicket, setForTicket] = useState(false);
  const [search, setSearch] = useState(filters.filter || "");
  const [saleType, setSaleType] = useState(true);
  const [associatedDevice, setAssociateDevice] = useState(true);

  const [dates, setDates] = useState({
    dateFrom: !filters.dateFrom ? "" : filters.dateFrom,
    dateTo: !filters.dateTo ? "" : filters.dateTo,
  });

  const [documentType, setDocumentType] = useState(0);

  const handleChangeCheckbox = (e) => {
    if (e.target.name === "forDay") {
      setForDay(e.target.checked);
      setForTicket(false);
      setFilter("visualizeBy", 1);
    }
    if (e.target.name === "forTicket") {
      setForTicket(e.target.checked);
      setForDay(false);
      setFilter("visualizeBy", 2);
    }
  };

  const onChangeSearch = (e) => {
    setSearch(e.target.value);
  };

  const onChangeDate = (e) => {
    setDates({
      ...dates,
      [e.target.name]: moment(e.target.value).format("YYYY-MM-DD"),
    });
  };

  const onChangeDocumentType = (type) => {
    if (type === "afecta") {
      setDocumentType(39);
      setFilter("documentType", 39);
    } else if (type === "exenta") {
      setDocumentType(41);
      setFilter("documentType", 41);
    } else if (type === "ticket") {
      setDocumentType(1001);
      setFilter("documentType", 1001);
    } else {
      setDocumentType(61);
      setFilter("documentType", 61);
    }
  };

  const onClickTerminal = (terminal) => {
    setFilter("terminal", terminal);
  };

  const { dateFrom, dateTo } = dates;

  const appliedDateFilter = () => {
    if (dateFrom) {
      setFilter("dateFrom", moment(dateFrom).format("DD-MM-YYYY"));
    }
    if (dateTo) {
      setFilter("dateTo", moment(dateTo).format("DD-MM-YYYY"));
    }
  };

  const isTablet = useMediaQuery("max-width", 1100);
  const isMobile = useMediaQuery("max-width", 600);

  const entries = Object.entries(filters);

  if (!terminals) {
    return "loading....";
  }

  return (
    <div>
      <Grid>
        {!isMobile && (
          <div style={{ marginTop: "25px" }}>
            <TextField
              id="outlined-search"
              type="search"
              variant="outlined"
              placeholder="Nombre, numero, codigo.."
              style={{
                width: "90%",
                backgroundColor: "white",
              }}
              onChange={onChangeSearch}
              value={search}
              InputProps={{
                endAdornment: (
                  <SearchOutlinedIcon
                    style={{ color: "#707070" }}
                    position="end"
                    onClick={() => setFilter("filter", search)}
                  ></SearchOutlinedIcon>
                ),
              }}
            />
          </div>
        )}
        {/* <div className={classes.dataViewFilterContainer}>
          <Typography className={classes.dataViewFilterLabel}>
            Visualización de datos
          </Typography>
          <div className={classes.containerCheckbox}>
            <Checkbox
              name="forDay"
              checked={filters.visualizeBy === 1 ? true : false}
              icon={<CircleUnchecked />}
              checkedIcon={<RadioButtonCheckedOutlinedIcon />}
              style={{ color: "#12b1ee", padding: "0px" }}
              onChange={handleChangeCheckbox}
            />
            <Typography className={classes.labelCheckbox}>Por Día</Typography>
          </div>
          <div className={classes.containerCheckbox}>
            <Checkbox
              name="forTicket"
              checked={filters.visualizeBy === 2 ? true : false}
              icon={<CircleUnchecked />}
              checkedIcon={<RadioButtonCheckedOutlinedIcon />}
              style={{ color: "#12b1ee", padding: "0px" }}
              onChange={handleChangeCheckbox}
            />
            <Typography className={classes.labelCheckbox}>
              Por Boleta
            </Typography>
          </div>
        </div> */}
        <div style={{ display: "block", marginTop: "10px", height: "5%" }}>
          <div style={{ display: "flex" }}>
            <FilterListOutlinedIcon style={{ color: "#707070" }} />
            <Typography className={classes.labelCheckbox}>
              Filtros aplicados
            </Typography>
          </div>

          <div style={{ width: "180px" }}>
            {entries.map((entry) => {
              if (entry[1] && entry[0] !== "applied") {
                if (entry[0] !== "visualizeBy") {
                  return (
                    <Chip
                      label={
                        entry[0] === "documentType" && entry[1] === 39
                          ? "Afecta"
                          : entry[0] === "documentType" && entry[1] === 41
                          ? "Exenta"
                          : entry[0] === "documentType" && entry[1] === 1001
                          ? "Ticket de Venta"
                          : entry[0] === "documentType" && entry[1] === 61
                          ? "Nota Cred."
                          : entry[1]
                      }
                      clickable
                      color="primary"
                      style={{
                        marginLeft: "10px",
                        marginTop: "10px",
                      }}
                      onClick={() => {
                        if (entry[0] === "visualizeBy") {
                          setForDay(true);
                          setForTicket(false);
                        }
                        if (entry[0] === "filter") {
                          setSearch("");
                        }
                        if (entry[0] === "documentType") {
                          setDocumentType(0);
                        }
                        if (entry[0] === "dateFrom") {
                          setDates({
                            ...dates,
                            dateFrom: "",
                          });
                        }
                        if (entry[0] === "dateTo") {
                          setDates({
                            ...dates,
                            dateTo: "",
                          });
                        }
                        setFilter(
                          entry[0],
                          entry[0] === "visualizeBy"
                            ? 1
                            : entry[0] === "documentType"
                            ? null
                            : ""
                        );
                      }}
                      deleteIcon={<DoneIcon />}
                    />
                  );
                }
              }
            })}
          </div>
        </div>
        <div style={{ marginTop: "10%" }}>
          <Typography className={classes.dataViewFilterLabel}>Fecha</Typography>
          <div style={{ height: "60px", marginTop: "20px" }}>
            <input
              type="text"
              placeholder="Desde"
              name="dateFrom"
              value={dateFrom}
              style={{ width: !isMobile ? "150px" : "90px", height: "32px" }}
              onFocus={(e) => (e.currentTarget.type = "date")}
              onChange={onChangeDate}
            />
            <input
              type="text"
              placeholder="Hasta"
              name="dateTo"
              value={dateTo}
              style={{
                width: !isMobile ? "150px" : "90px",
                height: "32px",
                marginLeft: !isTablet || isMobile ? "3%" : "0px",
              }}
              onFocus={(e) => (e.currentTarget.type = "date")}
              onChange={onChangeDate}
            />
            <Fab
              size="small"
              aria-label="add"
              style={{
                backgroundColor: "#12b1ee",
                marginLeft: "8px",
                marginTop: isTablet ? "2%" : "0%",
              }}
              onClick={appliedDateFilter}
            >
              <ArrowForwardIosOutlinedIcon style={{ color: "white" }} />
            </Fab>
          </div>
        </div>
        <div style={{ marginTop: "10px" }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <Typography className={classes.dataViewFilterLabel}>
              Tipo de Venta
            </Typography>
            <ArrowDown
              style={{ cursor: "pointer" }}
              onClick={() => setSaleType(!saleType)}
            />
          </div>

          {saleType && (
            <div
              style={{
                height: "60px",
                marginTop: "20px",
                display: "inline-grid",
              }}
            >
              <span
                name="Afecta"
                value={documentType}
                style={{
                  fontWeight: documentType === 39 && "bold",
                  cursor: "pointer",
                }}
                onClick={() => onChangeDocumentType("afecta")}
              >
                Afecta
              </span>

              <span
                name="Exenta"
                value={documentType}
                style={{
                  fontWeight: documentType === 41 && "bold",
                  cursor: "pointer",
                }}
                onClick={() => onChangeDocumentType("exenta")}
              >
                Exenta
              </span>

              <span
                name="Nota Cred."
                value={documentType}
                style={{
                  fontWeight: documentType === 61 && "bold",
                  cursor: "pointer",
                }}
                onClick={() => onChangeDocumentType("nota_cred")}
              >
                Nota Cred.
              </span>

              <span
                name="Ticket de Venta"
                value={documentType}
                style={{
                  fontWeight: documentType === 1001 && "bold",
                  cursor: "pointer",
                }}
                onClick={() => onChangeDocumentType("ticket")}
              >
                Ticket de Venta
              </span>
            </div>
          )}
        </div>
        <div style={{ marginTop: "10px" }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <Typography className={classes.dataViewFilterLabel}>
              Dispositivo asociado
            </Typography>
            <ArrowDown
              style={{ cursor: "pointer" }}
              onClick={() => setAssociateDevice(!associatedDevice)}
            />
          </div>
          {associatedDevice && (
            <div
              style={{
                height: "100px",
                width: "200px",
                overflowY: "scroll",
                marginTop: "20px",
                display: "inline-grid",
              }}
            >
              {terminals.map((terminal, index) => (
                <span
                  key={index}
                  value={terminal}
                  style={{ cursor: "pointer", padding: "3px" }}
                  onClick={() => onClickTerminal(terminal)}
                >
                  {terminal}
                </span>
              ))}
            </div>
          )}
        </div>
      </Grid>
    </div>
  );
};

export default FiltersTransactions;
